import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FEATURE_NAME, ScenarioState} from './scenario.state';

export const selectScenarioState = createFeatureSelector<ScenarioState>(FEATURE_NAME);

export const selectFilteredScenariosWithCurrentPage = createSelector(
  selectScenarioState,
  (state) => {
    if (state.filter?.page === null
      || state.filter?.page === undefined
      || !state.pages[state.filter.page]) {
      return [];
    }

    return state.pages[state.filter.page]
      .map((id) => state.entities[id]) ?? [];
  }
);

export const selectAllScenarios = createSelector(
  selectScenarioState,
  (state) => state ? Object.values(state.entities) : []
);

export const selectScenarioById = (id: string) => createSelector(
  selectScenarioState,
  (state: ScenarioState) => state.entities.hasOwnProperty(id)
    ? state.entities[id]
    : null
);

export const selectScenarioHistory = createSelector(
  selectScenarioState,
  (state: ScenarioState) => state.history
);

export const selectIsScenariosLoading = createSelector(
  selectScenarioState,
  (state) => state.isLoading
);

export const selectScenariosTotalCount = createSelector(
  selectScenarioState,
  (state) => state.totalCount
);

export const selectScenarioFilter = createSelector(
  selectScenarioState,
  (state) => state.filter
);

export const selectScenarioHistoryFilter = createSelector(
  selectScenarioState,
  (state) => state.historyFilter
);

export const selectRunningScenario = createSelector(
  selectScenarioState,
  (state) => state.runningScenario
);
